export const initialFilter = {
  direction: { selected: [], selectedIds: [], search: '' },
  block: { selected: [], selectedIds: [], search: '' },
  demandGop: { selected: [], selectedIds: [], search: '' },
  focusGop: { selected: [], selectedIds: []},
  created: { startDate: '', endDate: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  dataTable: { startDate: '', endDate: '' },
  status: { selected: ['Не начато', 'В процессе', 'Просрочено'], selectedIds: [227, 228, 229] },
  meeting: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpen = {
  direction: false,
  block: false,
  demandGop: false,
  focusGop: false,
  created: false,
  responsible: false,
  dataTable: false,
  status: false,
  meeting: false,
};

export const filterConfigGOS = {
  direction: {
    title: 'Направление',
    hasSearch: true,
    searchPlaceholder: 'Поиск по направлению',
    options: [],
  },
  block: {
    title: 'Блок',
    hasSearch: true,
    searchPlaceholder: 'Поиск по блоку',
    options: [],
  },
  demandGop: {
    title: 'Требование',
    hasSearch: true,
    searchPlaceholder: 'Поиск по требованию',
    options: [],
  },
  focusGop: {
    title: 'Фокусный GOP',
    options: [],
    hasSearch: false,
  },
  created: {
    title: 'Дата создания действия',
    hasSearch: false,
  },
  responsible: {
    title: 'Ответственный за действие',
    searchPlaceholder: '',
    hasSearch: false,
  },
  dataTable: {
    title: 'Срок выполнения действия',
    hasSearch: false,
  },
  status: {
    title: 'Статус действия',
    options: [],
    hasSearch: false,
  },
  meeting: {
    title: 'Название совещания',
    options: [],
    hasSearch: true,
    searchPlaceholder: 'Найти совещание',
  },
};
